import { SelectionModel } from '@angular/cdk/collections';
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService, TimeApiService } from 'cbc-shared-lib';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke012aRequest, Sgke012aResponse, Sgke012aResponseSearchResultList, Sgke012aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { trim } from 'lodash';
@Injectable({
  providedIn: 'root'
})
/**
 *
 * 未精算整理照会
 * @export
 * @class UsedSgke012aService
 */
export class UsedSgke012aService {

  /* 検索結果のSubject */
  private _searchResult$ = new Subject<Sgke012aResponse>();

  /* 検索結果のobservable提供 */
  get searchedValueChanges() {
    return this._searchResult$.asObservable();
  }

  private _singleSelection: SelectionModel<Sgke012aResponseSearchResultList> = new SelectionModel<Sgke012aResponseSearchResultList>(false, []);
  public get singleSelection(): SelectionModel<Sgke012aResponseSearchResultList> {
    return this._singleSelection;
  }

  /** 検索済フラグ */
  public searched: boolean = false;
  /** 情報クリアフラグ */
  public clear: boolean = false;

  /** 検索フォーム情報(画面戻り用) */
  public searchFormValue: Sgke012aRequest;

  /**コンストラクタ */
  constructor(public service: Sgke012aService, private apiCommonService: ApiCommonService, private timeApiService: TimeApiService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /** 未精算整理照会検索API */
  public doSgke012a(request: Sgke012aRequest): Observable<Sgke012aResponse> {
    //日付のフォーマットをYYMMDDに変更
    this.apiCommonService.convertElementInObject(request, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);
    this.chkStringValue(request);
    return this.service.ke10RSGKE012APost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE012A');
          return throwError(err.message);
        })
      );
  }
  /** クリア処理 */
  public doClear() {
    this.searched = false;
    this.searchFormValue = undefined;
  }
  /** 支払契約番号、入金番号クリア処理　*/
  private chkStringValue(request: Sgke012aRequest) {
    let trimPayCtrNo = trim(request.extractionconditionInfo.payCtrNo);
    if (trimPayCtrNo.length == 0) {
      request.extractionconditionInfo.payCtrNo = null;
    }
    let trimRcvmnyNo = trim(request.extractionconditionInfo.rcvmnyNo);
    if (trimRcvmnyNo.length == 0) {
      request.extractionconditionInfo.rcvmnyNo = null;
    }
  }
}
